import {type FromSchema} from 'json-schema-to-ts'

export const productTypeDefinitionsChangeNotification = {
  $id: 'http://example.com/example.json',
  type: 'object',
  title: 'The root schema',
  description: 'The root schema comprises the entire JSON document.',
  default: {},
  examples: [
    {
      NotificationVersion: '1.0',
      NotificationType: 'PRODUCT_TYPE_DEFINITIONS_CHANGE',
      PayloadVersion: '1.0',
      EventTime: '2021-02-03T18:59:30.194Z',
      Payload: {
        AccountId: 'AXXXXXXXXXXX',
        MarketplaceId: 'ATVPDKIKX0DER',
        ProductTypeVersion: 'Uyp-Z6z_y2HhQD2x8sDBXkRAuxBqBionr',
        NewProductTypes: ['LUGGAGE', 'SHOES'],
      },
      NotificationMetadata: {
        ApplicationId: 'amzn1.sellerapps.app.f1234566-aaec-55a6-b123-bcb752069ec5',
        SubscriptionId: '93b098e1-c42-2f45-93a1-78910a6a8369',
        PublishTime: '2021-02-03T18:59:30.194Z',
        NotificationId: '0e999936-da2c-4f9c-9fc2-02b67bae5f49',
      },
    },
  ],
  required: [
    'NotificationVersion',
    'NotificationType',
    'PayloadVersion',
    'EventTime',
    'Payload',
    'NotificationMetadata',
  ],
  properties: {
    NotificationVersion: {
      $id: '#/properties/NotificationVersion',
      type: 'string',
      title: 'The NotificationVersion schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['1.0'],
    },
    NotificationType: {
      $id: '#/properties/NotificationType',
      type: 'string',
      title: 'The NotificationType schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['PRODUCT_TYPE_DEFINITIONS_CHANGE'],
    },
    PayloadVersion: {
      $id: '#/properties/PayloadVersion',
      type: 'string',
      title: 'The PayloadVersion schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['1.0'],
    },
    EventTime: {
      $id: '#/properties/EventTime',
      type: 'string',
      title: 'The EventTime schema',
      description: 'An explanation about the purpose of this instance.',
      default: '',
      examples: ['2019-03-20T18:59:30.194Z'],
    },
    Payload: {
      $id: '#/properties/Payload',
      type: 'object',
      title: 'The Payload schema',
      description: 'An explanation about the purpose of this instance.',
      default: {},
      examples: [
        {
          AccountId: 'AXXXXXXXXXXX',
          MarketplaceId: 'ATVPDKIKX0DER',
          ProductTypeVersion: 'Uyp-Z6z_y2HhQD2x8sDBXkRAuxBqBionr',
          NewProductTypes: ['LUGGAGE', 'SHOES'],
        },
        {
          AccountId: 'AXXXXXXXXXXX',
          ProductTypeVersion: 'Uyp-Z6z_y2HhQD2x8sDBXkRAuxBqBionr',
        },
      ],
      required: ['AccountId', 'ProductTypeVersion'],
      properties: {
        MarketplaceId: {
          $id: '#/properties/Payload/properties/MarketplaceId',
          type: 'string',
          title: 'The MarketplaceId schema',
          description: 'The marketplace where the Product Type Definition has changed',
          default: '',
          examples: ['ATVPDKIKX0DER'],
        },
        AccountId: {
          $id: '#/properties/Payload/properties/AccountId',
          type: 'string',
          title: 'The Merchant Id or Vendor Group Id.',
          description: 'The Merchant Id or Vendor Group Id related to the subscription.',
          default: '',
          examples: ['AXXXXXXXXXXX'],
        },
        ProductTypeVersion: {
          $id: '#/properties/Payload/properties/ProductTypeVersion',
          type: 'string',
          title: 'The version of latest Product Type Definitions',
          description: 'Provides the latest released Product Type Definition version.',
          default: '',
          examples: ['Uyp-Z6z_y2HhQD2x8sDBXkRAuxBqBionr'],
        },
        NewProductTypes: {
          $id: '#/properties/Payload/properties/NewProductTypes',
          type: 'array',
          title: 'New Product Types',
          description: 'List of new Product Types release in the marketplace.',
          default: '',
          examples: [['LUGGAGE', 'SHOES']],
        },
      },
      additionalProperties: true,
    },
    NotificationMetadata: {
      $id: '#/properties/NotificationMetadata',
      type: 'object',
      title: 'The NotificationMetadata schema',
      description: 'An explanation about the purpose of this instance.',
      default: {},
      examples: [
        {
          ApplicationId: 'amzn1.sellerapps.app.f1234566-aaec-55a6-b123-bcb752069ec5',
          SubscriptionId: '93b098e1-c42-2f45-93a1-78910a6a8369',
          PublishTime: '2019-03-20T18:59:48.768Z',
          NotificationId: '8e009934-da2c-4f9c-9bc7-93f23b7e1f60',
        },
      ],
      required: ['ApplicationId', 'SubscriptionId', 'PublishTime', 'NotificationId'],
      properties: {
        ApplicationId: {
          $id: '#/properties/NotificationMetadata/properties/ApplicationId',
          type: 'string',
          title: 'The ApplicationId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['amzn1.sellerapps.app.f1234566-aaec-55a6-b123-bcb752069ec5'],
        },
        SubscriptionId: {
          $id: '#/properties/NotificationMetadata/properties/SubscriptionId',
          type: 'string',
          title: 'The SubscriptionId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['93b098e1-c42-2f45-93a1-78910a6a8369'],
        },
        PublishTime: {
          $id: '#/properties/NotificationMetadata/properties/PublishTime',
          type: 'string',
          title: 'The PublishTime schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['2019-03-20T18:59:48.768Z'],
        },
        NotificationId: {
          $id: '#/properties/NotificationMetadata/properties/NotificationId',
          type: 'string',
          title: 'The NotificationId schema',
          description: 'An explanation about the purpose of this instance.',
          default: '',
          examples: ['8e009934-da2c-4f9c-9bc7-93f23b7e1f60'],
        },
      },
      additionalProperties: true,
    },
  },
  additionalProperties: true,
} as const

export type ProductTypeDefinitionsChangeNotification = FromSchema<
  typeof productTypeDefinitionsChangeNotification
>
